import { fieldTypes, valueTypes } from '../../../types/common/commonTypes'
import { partFields, partState } from '../../../types/part/partTypes'

export const initialPartState: partState = {
    fields: [
        {
            field: partFields.conditionId,
            fieldType: fieldTypes.select,
            valueType: valueTypes.number,
            title: 'Состояние',
            specialProps: {
                isRequired: true,
                placeholder: 'выберите состояние',
                column: 1,
            },
        },
    ],
}
